import {useState} from "react";
import useAxios from "axios-hooks";
import DeleteConfirmationDialog from "../../../Util/DeleteConfirmationDialog";

const DeleteChecklistModal = ({
  showModal,
  toggleShowModal,
  onDelete,
  checklistId,
  setErrorMsg,
  setShowError,
  setShowSuccess,
  checklistName,
  checklistStatus,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [{ loading }, executeDelete] = useAxios(
    {
      method: "delete",
      url: `checklist/${checklistId}/`,
    },
    { manual: true }
  );      

    const handleDelete = async () => {
    try {
      const response = await executeDelete();
      if (response?.status >= 200 && response?.status < 300) {
        setErrorMessage("");
        onDelete?.();
        toggleShowModal();
        setShowSuccess?.(true);
        setTimeout(() => {
          setShowSuccess?.(false);
          window.location.reload();
        }, 2000);
        return true;
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message || error?.response?.data || error?.message;
      const resolvedMessage =
        apiMessage ||
        "Unable to delete this checklist. Please ensure it is not in use and try again.";

      setErrorMessage(resolvedMessage);
      setShowError?.(true);
      setErrorMsg?.(resolvedMessage);
    }
    return false;
  };

  const expectedValue = checklistName || "delete";

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessage("");
        toggleShowModal();
      }}
      onConfirm={handleDelete}
      resourceName={checklistName}
      resourceType="checklist"
      message={
        checklistStatus === "Draft"
          ? `This will permanently delete the draft checklist "${checklistName}" and all of its associated data. This action cannot be undone. Do you want to continue?`
          : `This will not permanently delete the checklist "${checklistName}". It will be set to inactive and will no longer be visible to users. You can reactivate it later if needed. Do you want to continue?`
      }
      confirmationValue={expectedValue}
      isDeleting={loading}
      errorMessage={errorMessage}
    />
  );
};

export default DeleteChecklistModal;